<template lang="pug">
#companion-guide-main
  BLoading(:active="guideLoading" :is-full-page="true")
  .companion-guide-content-wrapper(v-if="!guideLoading")
    .companion-guide-content
      .companion-action-menu
        CompanionActionsMenu(:backButton="showAudioPlayer ? musicPlayerBackButton: goBack")
      .show-guide-details
        .green-card(:style="{ backgroundColor: backgroundColor }")
          .cover-art
            img(:src="guideData.HeroImage")
        .guide-details-card
          .guide-topic-title {{ guideData.TopicTitle }}
          .guide-number-title {{ guideData.Number }} - {{ guideData.Title }}
          .chapters-info-title
            WtSvgIcon( icon="icon_time" width="16px", height="16px" ).mt-1
            span {{ guideData.Duration }} | {{ guideData.NumberOfChapters }} chapters
          .buttons-wrapper
            button(@click="playAudioFromChapterNumber(1)" :class="{ 'blue-button': true }")
              .play-button
                WtSvgIcon(icon="companion/plain_play_white" width="16px" height="16px").mt-1
                span Play guide
            //- button(@click="playAudioFromChapterNumber(1)" :class="{ 'blue-button': true }" )
            //-   .play-button
            //-     WtSvgIcon(icon="companion/article_white" width="16px" height="16px").mt-1
            //-     span Read guide
          .guide-part-summary(v-html="guideData.IntroText")
      BModal(:active.sync="audioPlayerModalOpen").show-auido-player
        .audio-load-failed(v-if="showAudioLoadFailed")
          WtTitle(h3) Oops! something went wrong. Please try again after sometime.
        .audio-player-wrapper(v-else :style="{ backgroundColor: musicPlayerBackgroundColor }" :class="{ 'is-loading': isAudioLoading }")
          div.icon-container(v-if="isAudioLoading")
            WtSvgIcon.m-auto(icon="companion/audio_spinner" width="76px" height="76px")
          .music-player
            .close-icon( @click="musicPlayerBackButton")
              WtSvgIcon( icon="companion/close_x" width="14px" height="14px")
            .toggle-read-play
              //- WtSvgIcon( icon="companion/plain_play" width="24px", height="24px")
              //- WtSvgIcon( icon="companion/article" width="24px", height="24px")
            .green-card(:style="{ backgroundColor: backgroundColor }")
              .cover-art-player
                img(:src="guideData.PlayerImage")
            .track-info
              .part-and-title
                span {{ guideData.Number }} - {{ guideData.Title }}
              .chapters-info-title-player
                  WtSvgIcon( icon="companion/time_white" width="16px", height="16px").mt-1
                  span {{ guideData.Duration }} | {{ guideData.NumberOfChapters }} chapters
              .current-chapter
                span {{ currentChapterTitle }}
            .progress-container
              input.custom-slider(
                class="slider"
                type="range"
                v-model="progress"
                @change="updateProgressAndSeek"
                :min="0"
                :max="duration"
                :style="{ '--progress': (progress / duration) * 100 + '%' }"
              )
              .time-info
                span {{ formatTime(progress) }}
                span {{ formatTime(duration) }}
            .controls
              .skip-button(@click="goToPreviousChapter", v-html="require(`!!html-loader!@@@/companion/skip_backward.svg`)")
              .skip-button(@click="skipBackward", v-html="require(`!!html-loader!@@@/companion/skip_backward_15sec.svg`)")
              .play-icon(v-if="isPlaying" v-html="require(`!!html-loader!@@@/companion/pause.svg`)" @click="togglePlay")
              .pause-icon(v-else v-html="require(`!!html-loader!@@@/companion/play.svg`)" @click="togglePlay")
              .skip-button(@click="skipForward", v-html="require(`!!html-loader!@@@/companion/skip_forward_15sec.svg`)")
              .skip-button(@click="goToNextChapter", v-html="require(`!!html-loader!@@@/companion/skip_forward.svg`)", :disabled="isLastChapter",:class="{ 'disabled': isLastChapter }")
  .companion-guide-chapters-wrapper(v-if="!guideLoading && !showAudioPlayer")
    .guide-chapters
      .chapters-title Chapters
      .chapters-list
        div(v-for="chapter in guideData.Chapters" :key="chapter.Number")
          .right-arrow-card
            CompanionRightArrowCard(@click.native="playAudioFromChapterNumber(chapter.Number)" :title="`${chapter.Number} - ${chapter.Title}`" )
        .companion-next-guide-content-wrapper(v-if="!guideLoading && !showAudioPlayer && nextGuide")
          .next-guide-details-card
            p Next guide
            .guide-card-container
              CompanionGuideCard(
                  :previewImage="nextGuide.PreviewImage"
                  :id="nextGuide.Id"
                  :duration="nextGuide.Duration"
                  :partTitle="nextGuide.Title"
                  :redirectTo="nextGuideLink"
                  :partNumber="nextGuide.Number"
                )
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import CompanionTopicCard from "@@/Companion/CompanionTopicCard";
import CompanionGuideCard from "@@/Companion/CompanionGuideCard";
import CompanionRightArrowCard from "@@/Companion/CompanionRightArrowCard";

import { Howl } from "howler";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CompanionGuideDetail",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon,
    CompanionActionsMenu,
    CompanionTopicCard,
    CompanionGuideCard,
    CompanionRightArrowCard
  },
  data() {
    return {
      guideLoading: true,
      guideData: {},
      nextGuide: {},
      audioPlayerModalOpen: false,
      isAudioLoading: false,
      showAudioPlayer: false,
      sound: null,
      isPlaying: false,
      progress: 0,
      duration: 0,
      isSeeking: false, // Flag to indicate if user is seeking with the slider
      chapterTimeStamps: [],
      chapterTitles: [],
      backgroundColor: "#a4d8cb",
      musicPlayerBackgroundColor: "#161F3C",
      showAudioLoadFailed: false
    };
  },

  computed: {
    ...mapGetters("companion", ["getGuideById"]),

    nextGuideLink() {
      if (this.nextGuide && this.nextGuide.Id) {
        return `/plan/guide/${this.nextGuide.Id}`;
      }
      return "";
    },

    isLastChapter() {
      return this.currentChapterIndex === this.chapterTimeStamps.length - 1;
    },

    currentChapterTitle() {
      const currentPosition = this.progress;

      for (let i = 0; i < this.chapterTimeStamps.length; i++) {
        const currentTimestamp = this.chapterTimeStamps[i];
        const nextTimestamp = this.chapterTimeStamps[i + 1];

        if (
          currentPosition >= currentTimestamp &&
          (nextTimestamp === undefined || currentPosition < nextTimestamp)
        ) {
          const chapterNumber = i + 1;
          const chapterTitle = this.chapterTitles[i];
          return `Chapter ${chapterNumber} - ${chapterTitle}`;
        }
      }
      return "";
    }
  },

  watch: {
    "$route.params.guideId": function() {
      this.musicPlayerBackButton();
    },

    audioPlayerModalOpen(newValue) {
      if (!newValue) {
        this.musicPlayerBackButton();
      }
    }
  },

  async mounted() {
    this.$watch(
      "$route.params.guideId",
      async () => {
        try {
          this.guideLoading = true;
          const guideId = this.$route.params.guideId;
          let guideObject = this.getGuideById(guideId);

          if (Object.keys(guideObject).length === 0) {
            guideObject = await this.fetchGuide({
              guideId: guideId
            });
          }

          this.guideData = guideObject.data;
          this.nextGuide = guideObject.data.NextGuide;
          this.audioFileUrl = guideObject.data.AudioWithBackingMusicPath;
          this.backgroundColor = "#" + guideObject.data.BackgroundColor;
          this.chapterTitles = guideObject.data.Chapters.map(
            chapter => chapter.Title
          );
          this.chapterTimeStamps = guideObject.data.Chapters.map(chapter => {
            const timeComponents = chapter.Timestamp.split(":");
            return (
              parseInt(timeComponents[0]) * 60 + parseInt(timeComponents[1])
            );
          });
          this.guideLoading = false;
          this.loadAudio();
        } catch (e) {
          this.guideLoading = false;
          this.snackBar({
            duration: 5000,
            type: "is-danger",
            message: e.message
          });
        }
      },
      { immediate: true }
    );
  },

  methods: {
    ...mapActions("companion", ["fetchGuide"]),
    ...mapActions(["snackBar"]),

    goBack() {
      window.history.back();
    },

    loadAudio() {
      this.isAudioLoading = true;
      this.sound = new Howl({
        src: [this.audioFileUrl],
        onload: () => {
          this.duration = this.sound.duration();
          this.updateProgress();
          this.isAudioLoading = false;
        },
        onloaderror: () => {
          this.showAudioLoadFailed = true;
          this.snackBar({
            duration: 5000,
            type: "is-danger",
            message: "Failed to load audio"
          });
        },
        onend: () => {
          this.isPlaying = false;
        }
      });
    },

    formatTime(seconds) {
      const pad = (num, size) => ("000" + num).slice(size * -1);
      const time = parseFloat(seconds).toFixed(3);
      const hours = Math.floor(time / 60 / 60);
      const minutes = Math.floor(time / 60) % 60;
      const secondsLeft = Math.floor(time - minutes * 60);

      if (hours) {
        return (
          pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(secondsLeft, 2)
        );
      } else {
        return pad(minutes, 2) + ":" + pad(secondsLeft, 2);
      }
    },

    togglePlay() {
      if (this.sound && this.sound.playing()) {
        this.sound.pause();
      } else {
        this.sound.play();
      }
      this.isPlaying = !this.isPlaying; // Toggle the isPlaying state
    },

    playAudioFromChapterNumber(chapterNumber) {
      if (
        !isNaN(chapterNumber) &&
        chapterNumber >= 1 &&
        chapterNumber <= this.guideData.NumberOfChapters
      ) {
        this.audioPlayerModalOpen = true;
        const chapterTimestamp = this.chapterTimeStamps[chapterNumber - 1];

        this.seekTo(chapterTimestamp);
        this.switchShowAudioPlayer();
        this.sound.play();
        this.isPlaying = true;
      }
    },

    switchShowAudioPlayer() {
      this.showAudioPlayer = !this.showAudioPlayer;
    },

    musicPlayerBackButton() {
      this.sound.pause();
      this.isPlaying = false;
      this.showAudioPlayer = false;
      this.audioPlayerModalOpen = false;
    },

    seekTo(value) {
      this.isSeeking = true;
      const isPlaying = this.sound.playing();
      if (isPlaying) {
        this.sound.pause();
      }
      this.sound.seek(value);
      this.progress = value;
      if (isPlaying) {
        this.sound.play();
      }
      this.isSeeking = false;
    },

    skipBackward() {
      const currentPosition = this.sound.seek() || 0;
      const newPosition = Math.max(currentPosition - 15, 0); // Ensure newPosition >= 0
      this.seekTo(newPosition);
    },

    skipForward() {
      const currentPosition = this.sound.seek() || 0;
      const newPosition = currentPosition + 15; // Ensure newPosition <= duration
      if (newPosition >= this.duration) {
        return;
      }
      this.seekTo(newPosition);
    },

    goToPreviousChapter() {
      const currentPosition = this.sound.seek() || 0;
      const currentChapterIndex = this.chapterTimeStamps.findIndex(
        (timestamp, index, array) => {
          const nextTimestamp = array[index + 1];
          return (
            currentPosition >= timestamp &&
            (nextTimestamp === undefined || currentPosition < nextTimestamp)
          );
        }
      );

      if (currentChapterIndex > 0) {
        const previousChapterTimestamp = this.chapterTimeStamps[
          currentChapterIndex - 1
        ];
        this.seekTo(previousChapterTimestamp);
      } else {
        // If already at the beginning, go to the start of the current chapter
        this.seekTo(0);
      }
    },

    goToNextChapter() {
      const currentPosition = this.sound.seek() || 0;
      const currentChapterIndex = this.chapterTimeStamps.findIndex(
        (timestamp, index, array) => {
          return (
            currentPosition >= timestamp &&
            (array[index + 1] === undefined ||
              currentPosition < array[index + 1])
          );
        }
      );
      if (currentChapterIndex == this.chapterTimeStamps.length - 1) {
        return;
      }
      if (currentChapterIndex >= 0) {
        const nextChapterTimestamp = this.chapterTimeStamps[
          currentChapterIndex + 1
        ];
        if (nextChapterTimestamp !== undefined) {
          this.seekTo(nextChapterTimestamp);
        } else {
          // If already at the end, stay at the end of the current chapter
          this.seekTo(this.duration);
        }
      } else {
        this.seekTo(this.chapterTimeStamps[0]);
      }
    },

    onSliderChange(value) {
      this.progress = value;
    },

    updateProgressAndSeek() {
      const isPlaying = this.sound.playing();
      if (isPlaying) {
        this.sound.pause();
      }
      this.sound.seek(this.progress);
      if (isPlaying) {
        this.sound.play();
      }
    },

    updateProgress() {
      if (this.sound && this.sound.playing() && !this.isSeeking) {
        this.progress = this.sound.seek();
      }
      setTimeout(this.updateProgress, 1000);
    }
  }
};
</script>

<style scoped>
#companion-guide-main .icon-container {
}
@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.companion-guide-content-wrapper {
  background-color: white;
  border: 1px solid #d9dbe0;
  margin: auto;
  border-radius: 16px 16px 0px 0px;
  padding: 24px 24px 24px 24px;
  gap: 16px;
  width: 70%;
  left: 0;
  .companion-guide-content {
    .modal-close {
      display: none;
    }
    .companion-action-menu {
      padding-bottom: 16px;
    }

    .show-guide-details {
      .green-card {
        max-height: 220px;
        border-radius: 16px;
        .cover-art {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cover-art img {
          max-height: 220px;
          padding: 20px;
        }
      }

      .guide-details-card {
        padding-top: 28px;

        .guide-topic-title {
          color: #5a5c60;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0.25px;
        }

        .guide-number-title {
          color: #1b1d20;
          font-size: 24px;
          font-weight: 500;
          line-height: 30px;
          letter-spacing: 0.18px;
          padding-top: 9px;
        }

        .chapters-info-title {
          display: flex;
          gap: 4px;
          align-items: center;

          color: #5a5c60;
          font-size: 14px;
          font-weight: 600;
          line-height: 18px;
          padding: 9px 0px 24px 0px;
        }
        .buttons-wrapper {
          display: flex;
          gap: 16px;
          align-items: center;
          flex-wrap: wrap;

          .blue-button {
            background-color: #2972f0;
            border-radius: 6px;
            border: none;
            color: white;
            &:hover {
              cursor: pointer;
            }
          }
          .play-button {
            display: flex !important;
            width: 120px;
            padding: 4px 8px;
            justify-content: center !important;
            align-items: center !important;
            gap: 8px !important;

            span {
              font-size: 12px;
              font-weight: 500;
              line-height: 16px;
            }
            WtSvgIcon {
              margin-top: 7px;
            }
          }
        }

        .guide-part-summary {
          padding: 24px 16px 0px 0px;
          .avenir-medium {
            color: #1b1d20;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0.25px;
            padding-bottom: 8px;
          }

          p {
            color: #5a5c60;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.25px;
          }
        }
      }
    }
  }
}

.companion-guide-chapters-wrapper {
  margin: auto;
  max-width: 70%;
  background: #fbfbfb;
  border-radius: 0px 0px 16px 16px;

  .chapters-title {
    color: #1b1d20;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.15px;
    padding-bottom: 6px;
  }
  .guide-chapters {
    padding: 32px 24px;

    .chapters-list {
      .right-arrow-card {
        padding-top: 10px;
      }
    }

    .companion-next-guide-content-wrapper {
      .next-guide-details-card {
        padding-top: 28px;

        .guide-card-container {
          padding-top: 16px;
          margin-bottom: 16px;
          width: 334px;
          height: 156px;
        }

        p {
          color: #1b1d20;
          font-size: 18px;
          font-weight: 700;
          line-height: 24px;
          letter-spacing: 0.15px;
        }
      }
    }
  }
}

.show-auido-player {
  .audio-load-failed {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5%;
  }

  .audio-player-wrapper {
    border-radius: 16px !important;
    height: 835px;

    &.is-loading {
      position: relative;
      z-index: 10;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 16px;
        height: 800px;
      }

      pointer-events: none;
      border-radius: 16px;
      height: 800px;
    }

    .icon-container {
      width: 76px !important;
      height: 76px !important;
      position: absolute;
      top: calc(50% - 38px);
      left: calc(50% - 38px);
      z-index: 2;
      background: transparent;
      animation: rotate360 5s linear infinite;
      transform-origin: center;
    }

    .music-player {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 24px 48px 20px 48px;
      position: relative;

      .close-icon {
        position: absolute;
        top: 24px;
        right: 28px;

        &:hover {
          cursor: pointer;
        }
      }

      .toggle-read-play {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
      }

      .green-card {
        height: 370px;
        width: 100%;
        margin: 32px 0px 24px 0px;

        .cover-art-player {
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            height: 370px;
            padding: 30px;
          }
        }
      }

      .track-info {
        color: white;
        margin-bottom: 20px;
        text-align: center;

        .part-and-title {
          font-size: 16px;
          line-height: 20px;
          font-family: Manrope;
          font-weight: 600;
        }

        .chapters-info-title-player {
          display: flex;
          justify-content: center;
          gap: 4px;
          align-items: center;
          margin: 8px 0px 24px 0px;
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          line-height: 18px;

          .WtSvgIcon {
            margin-top: 7px;
          }
        }
      }

      .progress-container {
        width: calc(100%);
        display: flex;
        flex-direction: column;
        align-items: stretch;

        .custom-slider {
          -webkit-appearance: none;
          width: 95%;
          height: 5px;
          border-radius: 5px;

          &:hover {
            cursor: pointer;
          }

          background: linear-gradient(
            to right,
            white 0%,
            white var(--progress),
            rgba(255, 255, 255, 0.4) var(--progress),
            rgba(255, 255, 255, 0.4) 100%
          );
          outline: none;
          -webkit-transition: 0.2s;
          transition: opacity 1s;
          margin: auto;
          justify-content: center;
        }

        .custom-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: white;
          cursor: pointer;
          opacity: 1;
        }
      }

      .time-info {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        width: 98%;
        margin-left: 1%;
        color: white;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
        padding-top: 12px;
      }

      .controls {
        display: flex;
        justify-content: center;
        position: bottom;
        gap: 20px;
        align-items: center;
        margin-bottom: 32px;
        padding-top: 24px;

        .play-icon,
        .pause-icon {
          &:hover {
            cursor: pointer;
          }
          svg {
            height: 56px;
            width: 56px;
          }
        }

        .skip-button {
          &:hover {
            cursor: pointer;
          }
          svg {
            height: 40px;
            width: 40px;
          }
        }
      }
    }
  }
}

@media (max-width: 1440px) {
  .progress-container {
    min-width: 70%;
  }
}

@media (max-width: 768px) {
  .companion-guide-content-wrapper {
    min-width: 100%;
  }
  .companion-guide-chapters-wrapper {
    min-width: 100%;
    padding: 20px;
  }
  .progress-container {
    min-width: 80%;
  }
}

@media (max-width: 480px) {
  .companion-guide-chapters-wrapper {
    .guide-chapters {
      padding: 0px;
      .chapters-list {
        .right-arrow-card {
          padding-top: 8px;
        }
        .companion-next-guide-content-wrapper {
          .next-guide-details-card {
            .guide-card-container {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .chapters-title {
      padding-bottom: 10px;
    }
  }

  .companion-guide-content-wrapper {
    width: 100%;
    padding: 20px 20px 20px 20px;
    .companion-guide-content {
      .modal-content {
        max-height: 735px !important;
        position: fixed !important;
        bottom: 0 !important;
        left: -20px !important;
        right: 0 !important;
        top: 64px !important;
      }
      .show-guide-details {
        .guide-details-card {
          padding: 28px 1px 0px 1px;

          .buttons-wrapper {
            gap: 8px;

            .play-button {
              width: 150px;
            }
          }
          .guide-part-summary {
            .avenir-medium,
            p {
              padding-right: 40px;
            }
          }
        }
      }
    }
  }

  .show-auido-player {
    .audio-player-wrapper {
      .music-player {
        padding: 30px 30px 100px 30px;
        .green-card {
          height: 190px;
          width: 190px;
          margin: 34px 0px 40px 0px;
          border-radius: 8px;

          .cover-art-player {
            img {
              height: 190px;
              padding: 0px;
              border-radius: 8px;
            }
          }
        }

        .track-info {
          margin-bottom: 60px;
          .part-and-title {
            font-size: 20px;
            font-weight: 500;
            line-height: 26px;
          }
          .chapters-info-title-player {
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            margin: 40px 0px 8px 0px;
          }
        }
        .progress-container {
          .custom-slider {
            height: 3px;
          }

          .custom-slider::-webkit-slider-thumb {
            width: 15px;
            height: 15px;
          }
        }
        .controls {
          .play-icon,
          .pause-icon {
            svg {
              height: 80px;
              width: 80px;
            }
          }

          .skip-button {
            svg {
              height: 40px;
              width: 40px;
            }
          }
        }
      }
    }
  }

  .progress-container {
    min-width: 100%;
  }
}

@media (max-height: 768px) and (max-width: 468px) {
  /*
    For future reference
  .companion-guide-content-wrapper {
    .companion-guide-content {
      .modal-content {
        top: 0px !important;
      }
    }
  } */
  .show-auido-player {
    .audio-player-wrapper {
      top: 0 !important;
      .music-player {
        .green-card {
          margin: 18px 0px 12px 0px !important;
        }
        .track-info {
          margin-bottom: 20px !important;
          .part-and-title {
            font-size: 18px !important;
            line-height: 20px !important;
          }
        }
      }
    }
  }
}
</style>
